var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.9512 0H1.0488C0.46968 0 0 0.46968 0 1.0488V17.9512C0 18.5303 0.46968 19 1.0488 19H10.1483V11.6424H7.6722V8.77496H10.1483V6.65988C10.1483 4.20584 11.647 2.86976 13.8366 2.86976C14.8854 2.86976 15.7867 2.94804 16.0489 2.983V5.548L14.5304 5.54876C13.3395 5.54876 13.1092 6.1142 13.1092 6.94488V8.77572H15.9486L15.5785 11.6432H13.1085V19H17.9512C18.5303 19 19 18.5303 19 17.9512V1.0488C19 0.46968 18.5303 0 17.9512 0Z","fill":"white"}));
}

FacebookInline.defaultProps = {"width":"19","height":"19","viewBox":"0 0 19 19","fill":"none","className":"svg"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
